<template>
	<div class="solid-mesh-name-container">
		<ListItemLabel v-if="!isRenamingMode" class="solid-mesh-name-text" :text="solidMesh?.name ?? ''" />
		<v-text-field v-else v-model="editingName" @keydown.enter="onEnterKeydown" @blur="saveName" @keyup.esc="cancelRename"
			density="compact" hide-details variant="outlined" class="solid-mesh-name-input" autofocus></v-text-field>
	</div>
</template>

<script>
import { isImeComposingKeyEvent } from "@/utils/imeComposition";
import ListItemLabel from "@/components/Project/ListItemLabel.vue";
import { ObjectType } from "@/models/objects/types";

export default {
	name: "SolidMeshName",
	props: {
		solidMeshId: String,
		isRenamingMode: Boolean,
	},
	components: {
		ListItemLabel,
	},
	data() {
		return {
			editingName: "",
		};
	},
	computed: {
		solidMesh() {
			return this.$store.state.object.objects.find(
				(obj) =>
					obj.type === ObjectType.SOLID_MESH && obj.id === this.solidMeshId,
			);
		},
	},
	watch: {
		isRenamingMode(newValue) {
			if (newValue) {
				this.editingName = this.solidMesh.name;
			}
		},
	},
	methods: {
		async saveName() {
			if (this.editingName.trim() && this.editingName !== this.solidMesh.name) {
				try {
					this.solidMesh.setName(this.editingName.trim());
					this.$store.commit("set_snackbar", {
						text: `${this.$t("RENAME")} ${this.$t("successful")}`,
						color: "rgba(0, 153, 0, 0.72)",
					});
				} catch (error) {
					console.error("Failed to rename solid mesh:", error);
					this.$store.commit("set_snackbar", {
						text: `${this.$t("RENAME")} ${this.$t("failed")}`,
						color: "rgba(153, 0, 0, 0.72)",
					});
				}
			}
			this.$emit("end-rename");
		},

		/** Save on Enter, ignoring the one that confirms IME composition. */
		onEnterKeydown(e) {
			if (isImeComposingKeyEvent(e)) return;
			this.saveName();
		},

		cancelRename() {
			this.editingName = this.solidMesh.name;
			this.$emit("end-rename");
		},
	},
};
</script>

<style scoped>
.solid-mesh-name-container {
	flex: 1;
	min-width: 0;
}

.solid-mesh-name-input {
	font-size: 14px;
}

.solid-mesh-name-text {
	font-size: 14px;
	color: white;
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>
